import { Stack, Autocomplete, TextField, Typography, IconButton } from "@mui/material";
import { v4 as uuidv4 } from 'uuid';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { Fragment } from "react";

export const FormRent = ({ formValues, handleInputChange, dataProduct }) => {
    const { rents, firstDate, lastDate } = formValues;

    const handleChangeInput = (id, event) => {
        const newInputFields = rents?.map(i => {
            if (id === i.id) {
                i[event.target.name] = event.target.value
            }
            return i;
        })
        handleInputChange({ 'target': { 'name': 'rents', 'value': newInputFields } })
    }

    const handleAddFields = () => {
        handleInputChange({ 'target': { 'name': 'rents', 'value': [...rents, { id: uuidv4(), measure: '', size: '', price: '', concept: '', rentsDays: '' }] } })
    }

    const handleRemoveFields = id => {
        const values = [...rents];
        values.splice(values.findIndex(value => value.id === id), 1);
        handleInputChange({ 'target': { 'name': 'rents', 'value': values } })
    }

    const onChange = (e) => { 
        handleInputChange({
            target: {
                name: 'dates',
                value: e
            }
        })
    }

    return (
        <Stack flexDirection='row' width='100%' spacing={1} flexWrap='wrap' justifyContent='space-around' gap={1}>
            <Stack width='100%'>
                <Typography textAlign='center' variant="subtitle" color="primary">Alquileres</Typography>
            </Stack>
            {
                rents?.map(inputField => (
                    <Fragment key={inputField.id}>
                        <Stack flexDirection='row' gap={2} width='90%' justifyContent='space-around'>
                            <Autocomplete
                                options={dataProduct?.filter(d => d.type === 'Alquiler').map((d) => d.product).concat('') || ['Cargando productos']}
                                noOptionsText='Elige una opción correcta'
                                fullWidth
                                renderInput={(params) => <TextField name='concept'{...params} label="Concepto" required variant="filled" />}
                                onSelect={event => handleChangeInput(inputField.id, event)}
                                value={dataProduct?.filter(d => d.type === 'Alquiler').map((d) => d.product).includes(inputField.concept) ? inputField.concept : ''}
                            />
                            <TextField
                                label="Días de alquiler"
                                type="number"
                                variant="filled"
                                name='rentsDays'
                                value={inputField.rentsDays}
                                onChange={event => handleChangeInput(inputField.id, event)}
                                InputProps={{ inputProps: { min: 0 } }}
                                required
                            />
                        </Stack>
                        <Stack flexDirection='row' width='90%' justifyContent='space-between' flexWrap='wrap' >
                            <Autocomplete
                                disablePortal
                                options={measureOptions}
                                sx={{ width: 130 }}
                                size='small'
                                renderInput={(params) => <TextField name='measure'{...params} value={inputField.measure} label="Unidad" required variant="standard" />}
                                onSelect={event => handleChangeInput(inputField.id, event)}
                                value={measureOptions.includes(inputField.measure) ? inputField.measure : ''}
                                required
                            />
                            <TextField
                                sx={{ width: 130 }}
                                label="Tamaño"
                                type="number"
                                variant="standard"
                                size='small'
                                name='size'
                                value={inputField.size}
                                onChange={event => handleChangeInput(inputField.id, event)}
                                InputProps={{ inputProps: { min: 0 } }}
                                required
                            />
                            <TextField
                                sx={{ width: 130 }}
                                label="Precio"
                                type="number"
                                variant="standard"
                                size='small'
                                name='price'
                                value={inputField.price}
                                onChange={event => handleChangeInput(inputField.id, event)}
                                InputProps={{ inputProps: { inputMode: "decimal" } }}
                                required
                            />
                            <IconButton disabled={rents.length === 1} onClick={() => handleRemoveFields(inputField.id)}>
                                <DeleteIcon color='primary' />
                            </IconButton>
                            <IconButton
                                onClick={handleAddFields}
                            >
                                <AddIcon />
                            </IconButton>
                        </Stack>
                    </Fragment>
                ))}
            <Stack flexDirection='row' width='100%' justifyContent='space-around' flexWrap='wrap' >
                <Stack flexDirection='row' width='90%' justifyContent='flex-start' gap={2} alignItems='flex-end' >
                    <label >Fecha de alquiler:</label >
                    <DateRangePicker required format='dd/MM/yyyy' onChange={onChange} value={[firstDate, lastDate] || ['', '']} />
                </Stack>
            </Stack>
        </Stack>
    )
}

const measureOptions = ['m2', 'ud', 'm3', ''];